(function($)
{
    $.extend(true, orion, {
        api: {
            salesChargeback: {}
        }
    });

    var
        api = orion.api.salesChargeback,
        uri = '/api-sales-chargeback';

    function read()
    {
        var
            promise = $.ajax(uri, {
                'method': 'GET'
            });

        return promise;
    }

    api.read = read;
})(jQuery);
